/**
 * Every file type POST /import/organization/analyze reads, in one list so the
 * upload controls that send files there cannot drift apart again.
 *
 * .lnx/.bin are setup-wizard FlatBuffer exports, .sql a pg_dump or wizard SQL
 * export, .json/.json5 a wizard JSON export, and .dat the server export a
 * LiftNet v2.0–v2.2 deployment writes (GET /servers/export).
 */
export const IMPORT_FILE_EXTENSIONS: readonly string[] = [
  ".lnx",
  ".bin",
  ".sql",
  ".json",
  ".json5",
  ".dat",
];

/** The `accept` attribute value for an import file input. */
export const IMPORT_FILE_ACCEPT: string = IMPORT_FILE_EXTENSIONS.join(",");

/** Human-readable list, e.g. ".lnx, .bin, .sql, .json, .json5 or .dat". */
export const IMPORT_FILE_TYPES_LABEL: string = `${IMPORT_FILE_EXTENSIONS.slice(0, -1).join(", ")} or ${IMPORT_FILE_EXTENSIONS[IMPORT_FILE_EXTENSIONS.length - 1]}`;

/** Hint shown under an import drop zone. */
export const IMPORT_FILE_HINT: string =
  "Setup-wizard exports (.lnx, .bin, .sql, .json, .json5) and LiftNet v2.1/v2.2 server exports (.dat)";

/** Returns the lower-cased extension of name (".dat"), or "" when it has none. */
export function importFileExtension(name: string): string {
  const dot = name.lastIndexOf(".");
  return dot === -1 ? "" : name.slice(dot).toLowerCase();
}

/** True when name ends in one of IMPORT_FILE_EXTENSIONS, case-insensitively. */
export function isImportFile(name: string): boolean {
  return IMPORT_FILE_EXTENSIONS.includes(importFileExtension(name));
}
